import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import { Radio } from '@bingads-webui-react/radio';

import { CommentsField } from '@bingads-webui-campaign-react/recommendation-feedback-modal';
import {
  REASON_TABLE,
  OTHER_REASON,
  NUMBER_INPUT_REASON_LIST,
  PERCENT_INPUT_REASON_LIST,
  RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR,
  COMMENT_ONLY_REASON_LIST,
  COMMENT_WITH_URL_REASON_LIST,
  URL_FOR_COMMENT_WITH_URL_REASON_LIST,
} from './single-choice-reason-const';
import { PercentInput } from './customized-input/percent-input';
import { NumberInput } from './customized-input/number-input';

export class SingleChoiceDismissFeedbackForm extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    type: PropTypes.string.isRequired,
    changeState: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }),
    rejectAutoApplySuggestedAds: PropTypes.bool,
  };
  static defaultProps = {
    changeState: null,
    newI18n: {
      getString: _.noop,
    },
    rejectAutoApplySuggestedAds: false,
  };
  constructor(props) {
    super(props);

    this.state = {
      reasonId: null,
      reasonNote: '',
      notshowagain: false,
    };
    this.reasonSuggestedValue = '';
  }

  onSubmit = () => {
    const {
      reasonId, reasonNote, notshowagain,
    } = this.state;
    const {
      i18n, type, onSubmit,
    } = this.props;

    const reasonString = i18n.getString(`Recommendation_Feedback_Reason_${reasonId}`);

    const reasonIds = _.isNull(reasonId) ? [] : [reasonId];
    const submittedReason = JSON.stringify({
      reasonString,
      reasonIds,
      reasonNote: reasonNote || this.reasonSuggestedValue,
    });

    if (type === 'budgetLandscape') {
      onSubmit({ reason: submittedReason }, reasonId);
    } else {
      const expireTime = Date.now() + (notshowagain ? (30 * 24 * 60 * 60 * 1000) : 0);
      onSubmit(
        {
          reason: submittedReason,
          preference: {
            type,
            expireTime,
          },
        },
        reasonId
      );
    }
  };

  onReasonNoteChange = (value) => {
    this.setState({
      reasonNote: value,
    }, this.submitStateChange);
  };

  onPreferenceChange = (e) => {
    const { checked } = e.target;
    this.setState({
      notshowagain: checked,
    }, this.submitStateChange);
  };

  setReasonSuggestedValue = (value) => {
    this.reasonSuggestedValue = value;
  };

  handleReasonChange = (e) => {
    this.setState({
      reasonId: e.target.id,
      reasonNote: '',
    }, this.submitStateChange);
    this.reasonSuggestedValue = '';
  };

  submitStateChange() {
    if (this.props.changeState) {
      const submitDisabled = !this.state.notshowagain && this.state.reasonNote === '' && _.isEmpty(this.state.reasonId);
      this.props.changeState(submitDisabled);
    }
  }

  render() {
    const {
      reasonId, reasonNote,
    } = this.state;
    const submitDisabled = !this.state.notshowagain && this.state.reasonNote === '' && _.isEmpty(this.state.reasonId);
    const {
      i18n,
      type,
      newI18n,
      onCancel,
      rejectAutoApplySuggestedAds,
    } = this.props;

    // don't have to judge again whether type in reason table;
    // it is judged in the parent component
    const reasonIds = rejectAutoApplySuggestedAds ?
      undefined :
      REASON_TABLE[type];
    const isForBudgetLandscape = type === 'budgetLandscape';

    const title = isForBudgetLandscape ?
      i18n.getString('Budget_Landscape_Feedback_Title') :
      i18n.getString('Recommendation_Feedback_Dismiss_Title_New');

    // the budget landscape popup set position to absolute in css,
    // and the close button in campaign UI use different class name,
    // so we need to put the close button in form rather than popover.
    // If we don't do this, the close button would disappear.
    return (
      <div className="single-choice-feedback-form">
        <div className="single-choice-feedback-form-head">
          <div className="single-choice-feedback-form-title">
            {title}
            {isForBudgetLandscape && <button className="iconba iconba-Cancel close closeimage" aria-label="Close" onClick={onCancel} />}
          </div>
          <div className="single-choice-feedback-form-description">
            {!isForBudgetLandscape && i18n.getString('Recommendation_Product_Feedback_Loop_Make_Better_Description')}
          </div>
        </div>

        <React.Fragment>
          <div className="reasons form-group">
            {_.map(reasonIds, (id, index) => (
              <Radio
                key={id}
                id={id}
                name="reason"
                checked={id === reasonId}
                value={id}
                onChange={this.handleReasonChange}
              >
                {i18n.getString(`Recommendation_Feedback_Reason_${id}`) || i18n.getString(`Recommendation_Dismiss_Feedback_${id}`)}
                {_.isEqual(id, reasonId) && _.isEqual(index, reasonIds.length - 1) &&
                  <div className="comments form-group">
                    <CommentsField
                      id="comments"
                      name={OTHER_REASON}
                      value={reasonNote}
                      onChange={this.onReasonNoteChange}
                      i18n={i18n}
                      isProvideFeedbackOnly={false}
                      isProductFeedbackLoop
                    />
                  </div>
                }
                {_.isEqual(id, reasonId) && PERCENT_INPUT_REASON_LIST.includes(id) &&
                  <div className="reason-input">
                    <PercentInput
                      i18n={i18n}
                      newI18n={newI18n}
                      reasonId={reasonId}
                      callback={this.setReasonSuggestedValue}
                      comment={RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR[reasonId]}
                    />
                  </div>
                }
                {_.isEqual(id, reasonId) && NUMBER_INPUT_REASON_LIST.includes(id) &&
                  <div className="reason-input">
                    <NumberInput
                      i18n={i18n}
                      newI18n={newI18n}
                      reasonId={reasonId}
                      callback={this.setReasonSuggestedValue}
                      comment={RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR[reasonId]}
                    />
                  </div>
                }
                {_.isEqual(id, reasonId) && COMMENT_ONLY_REASON_LIST.includes(id) &&
                  <div className="reason-input">
                    {i18n.getString(RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR[reasonId])}
                  </div>
                }
                {_.isEqual(id, reasonId) && COMMENT_WITH_URL_REASON_LIST.includes(id) &&
                  <div className="reason-input">
                    <a
                      href={URL_FOR_COMMENT_WITH_URL_REASON_LIST[
                      COMMENT_WITH_URL_REASON_LIST[reasonId]]}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {i18n.getString(RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR[reasonId])}
                    </a>
                  </div>
                }

              </Radio>
            ))}
          </div>
        </React.Fragment>

        <div className="actions form-inline">
          <button
            disabled={submitDisabled}
            className="btn btn-hero btn-primary submit"
            onClick={this.onSubmit}
          >
            {i18n.getString('Recommendation_Feedback_Submit_Action')}
          </button>

          {!isForBudgetLandscape &&
            <div className="checkbox preference">
              <input
                id="checkbox_notshowagain"
                value={this.state.notshowagain}
                onChange={this.onPreferenceChange}
                type="checkbox"
              />
              <span className="not-show-again-text">
                {i18n.getString('Recommendation_Dismiss_Feedback_DontShowAgain')}
              </span>
            </div>
          }
        </div>
      </div>
    );
  }
}
